module.exports = __webpack_public_path__ + "static/media/tools-question2.0cac1ab4.svg";